export class Role {
  name: string;
  display_name: string;
  abilities: {VIEW: string[], CREATE: string[], EDIT: string[], REMOVE: string[]};

  constructor(name?:string, display_name?: string, abilities?: {VIEW: string[], CREATE: string[], EDIT: string[], REMOVE: string[]}) {
    this.name = name || null;
    this.display_name = display_name || null;
    this.abilities = abilities || {VIEW: [], CREATE: [], EDIT: [], REMOVE: []};
  }
}
